const copyright = new URL("ccBySa.png", import.meta.url).href;
const harvest = new URL("harvestEthiopia.jpg", import.meta.url).href;
const thresh = new URL("threshBangladesh.jpg", import.meta.url).href;
const winnow = new URL("winnowIndia.jpg", import.meta.url).href;

export { copyright, harvest, thresh, winnow };
